import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TLoginPageProps = {};

export const LoginPage: FC<TLoginPageProps> = () => {
  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      <LoginForm />
    </Stack>
  );
};
